import { Route } from "react-router-dom";
import { AuditSessionPageV2 } from "../pages/audit/AuditSessionPageV2";
import { AuditDocumentsPageV2 } from "../pages/audit/auditDocuments/AuditDocumentsPageV2";
import { AuditWorkpaperViewPageV2WithProvider } from "../pages/audit/auditWorkPaperView/AuditWorkPaperViewV2WithProvider";
import { AuditWorkPaperV2Page } from "../pages/audit/auditWorkPaperV2Page/AuditWorkPaperV2Page";

export const AuditRoutesV2 = [
  <Route
    key="control-audit-test"
    path=":controlSessionId"
    element={<AuditSessionPageV2 />}
  />,

  <Route
    key="control-audit-documents"
    path=":controlSessionId/documents"
    element={<AuditDocumentsPageV2 />}
  />,
  <Route
    key="control-audit-workpaper-view"
    path=":controlSessionId/workpaper-view"
    element={<AuditWorkpaperViewPageV2WithProvider />}
  />,
  <Route
    key="control-audit-workpaper-v2"
    path=":controlSessionId/workpaper-v2"
    element={<AuditWorkPaperV2Page />}
  />,
];
